import { schema } from "normalizr";

import { ApiModel } from "./model";

interface PlaylistTrends {
    total: number;
    trackCount: number;
    trackIds: Array<{
        id: number;
        total: number;
    }>;
    playlist_id: number;
    playlist: Playlist;
}

interface Playlist extends ApiModel {
    kind?: "playlist";
    name: string;
    url: string;
    vendor: string;
    vendor_id: string;
    public: boolean;
    description: string;
    meta: {
        [key: string]: any;
    };
    dsp_id: number;
    is_tracked: boolean;
    created_at: Date;
    updated_at: Date;
    snapshots?: PlaylistSnapshot[] | number[];
}

interface PlaylistSnapshot {
    id: number;
    num_followers: number;
    meta: {
        [key: string]: any;
    };
    playlist_id: number;
    created_at: Date;
    updated_at: Date;
    tracks: Track[] | number[];
}

interface Track {
    id: number;
    title: string;
    artists: string;
    album: string;
    isrc: string;
    url: string;
    vendor: string;
    vendor_id: string;
    meta: {
        [key: string]: any;
    };
    pivot?: PlaylistSnapshotTrack | string;
    playlists: Playlist[] | number[];
}

interface PlaylistSnapshotTrack {
    playlist_snapshot_id: number;
    vendor_track_id: number;
    order: number;
    added_at: Date;
    meta: {
        [key: string]: any;
    };
}

interface PlaylistTrack {
    track: Track;
    track_id: number;
    playlist: Playlist;
    playlist_id: number;
    vendor: string;
    streams: number;
}

const NPlaylistSnapshotTrack = new schema.Entity("playlistSnapshotTracks", {}, {
    idAttribute: (value: PlaylistSnapshotTrack) => {
        return value.playlist_snapshot_id + "_" + value.vendor_track_id;
    },
});

const NTrack = new schema.Entity("vendorTracks");

const NPlaylistSnapshot = new schema.Entity("playlistSnapshots", {
    tracks: [NTrack],
});

const NPlaylist = new schema.Entity("playlists", {
    snapshots: [NPlaylistSnapshot],
});

const NPlaylistTrends = new schema.Object({
    playlist: NPlaylist,
});
NTrack.define({
    pivot: NPlaylistSnapshotTrack,
    playlists: [NPlaylist],
});

const NPlaylistTrack = new schema.Entity("playlistTracks", {
    track: NTrack,
    playlist: NPlaylist,
}, {
    idAttribute: (value: PlaylistTrack) => {
        return value.vendor + "_" + value.track_id + "_" + value.playlist_id;
    },
});

interface VendorNormalisedEntities {
    playlists?: {
        [key: number]: Playlist;
    };
    playlistSnapshots?: {
        [key: number]: PlaylistSnapshot;
    };
    playlistSnapshotTracks?: {
        [key: number]: PlaylistSnapshotTrack;
    };
    vendorTracks?: {
        [key: number]: Track;
    };
    playlistTracks?: {
        [key: string]: PlaylistTrack;
    };
}

export {
    PlaylistTrends,
    Playlist,
    PlaylistSnapshot,
    Track,
    PlaylistSnapshotTrack,
    PlaylistTrack,
    NPlaylistSnapshotTrack,
    NTrack,
    NPlaylistSnapshot,
    NPlaylist,
    NPlaylistTrends,
    NPlaylistTrack,
    VendorNormalisedEntities,
};
